import { TranslateService } from '@ngx-translate/core';

export function tooltipLabel(translate: TranslateService, property: string) {
    const translations = translate.instant(property)
    return translations !== property ? translations : '';
}


